import * as R from 'ramda';
import {observable, flow, runInAction} from 'mobx';
import proxyRequest, {httpMethods} from 'js/proxy_api_client';

export class ManualDistributionStore {
    static viewOptions = {
        IN_FEED: 'infeed',
        STORY: 'story'
    };

    @observable didFetchDistribution = false;
    @observable.struct fetchError = null;
    @observable.struct distribution = {};
    @observable view = null;

    constructor({view} = {}) {
        runInAction(() => {
            this.view = view;
        });
    }

    fetchDistribution = flow(function*(query = {}) {
        this.didFetchDistribution = false;

        try {
            this.fetchError = null;

            const {data} = yield proxyRequest(
                httpMethods.GET,
                'api/v1/content_metadata_distribution',
                {
                    params: query
                }
            );

            /** Api Proxy Controller coerces {} to [] */
            if (data && R.isEmpty(data)) {
                this.distribution = {};
                this.didFetchDistribution = true;
                return;
            }

            this.distribution = data;
            this.didFetchDistribution = true;
        } catch (error) {
            this.fetchError = error;
        }
    });
}



// WEBPACK FOOTER //
// ./components/manual_distribution_modal/state.js